import { useState } from 'react';
import { api, fmtDate } from '../api';

const inputDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

// Guarda solo esta suscripción; no altera los datos del cliente ni sus pagos.
export default function SubscriptionDueDateField({ subscription, onSaved }) {
  const [date, setDate] = useState(() => inputDate(subscription.nextDueDate));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  const service = (subscription.kind === 'combo' ? subscription.comboId?.name : subscription.platformId?.name) || 'Servicio';

  const save = async () => {
    setBusy(true);
    setError('');
    setSaved(false);
    try {
      const updated = await api(`/subscriptions/${subscription._id}/due-date`, {
        method: 'PATCH',
        body: { nextDueDate: date },
      });
      onSaved(updated);
      setSaved(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-2 rounded-lg border border-slate-800 p-3">
      <div className="text-sm font-medium">
        {service} · {subscription.unit === 'cuenta' ? 'cuenta' : 'perfil'}
        {subscription.profileName && ` · ${subscription.profileName}`}
      </div>
      <p className="text-xs text-slate-400">Fecha actual: {fmtDate(subscription.nextDueDate)}</p>
      <div className="flex flex-wrap items-end gap-2">
        <label className="field-label min-w-0 flex-1" htmlFor={`renewal-${subscription._id}`}>
          Fecha de renovación
          <input id={`renewal-${subscription._id}`} className="input mt-1" type="date" value={date} disabled={busy}
            onChange={(event) => { setDate(event.target.value); setSaved(false); setError(''); }} />
        </label>
        <button type="button" className="btn-ghost" disabled={busy || !date || date === inputDate(subscription.nextDueDate)} onClick={save}>
          {busy ? 'Guardando…' : 'Guardar fecha'}
        </button>
      </div>
      {error && <p className="text-sm text-red-400" role="alert">{error}</p>}
      {saved && <p className="text-xs text-emerald-400" role="status">Fecha actualizada. No se registró ningún pago.</p>}
    </div>
  );
}
